export default {
  header: {
    title: 'Nuevo despacho',
    dashboard: 'Dashboard',
    management: 'Management',
    dispatches: 'Dispatches',
    client: 'Cliente',
    workflow: 'Workflow',
    program: 'Programa'
  },
  steps: {
    'Find Customer': 'Find Customer',
    'Select Service': 'Select Service',
    'Select Pick Up Time': 'Select Pick Up Time',
    'Select Pick Up Location': 'Select Pick Up Location',
    'Select Drop Off Location': 'Select Drop Off Location',
    'Select Provider': 'Select Provider',
    'Select Tire': 'Seleccionar Neumático'
  },
  forms: {
    couldNotLocateCustomerButton: 'No se pudo localizar al cliente',
    customer: 'Cliente',
    customerHelpText: 'Puede buscar por nombre y apellido o marca del vehículo, modelo y año o vin o correo electrónico o número de teléfono (números solo para un número de teléfono. No se necesitan guiones ni paréntesis) o número de miembro',
    name: 'Nombre',
    memberNumber: 'Número de miembro',
    email: 'Email',
    phones: 'Los telefonos',
    address: 'Direccion',
    vehicles: 'Vehículos',
    chooseAVehicle: 'Elija un vehículo',
    requiredAVehicle: 'Se requiere vehículo. Editar cliente para agregar un vehículo',
    requiredVin: 'Se requiere el VIN del vehículo. Edite el cliente para agregar el VIN de un vehículo',
    addANewVehicle: 'Añadir nuevo vehículo',
    callerIsInASafeLocation: 'La persona que llama está en un lugar seguro',
    antiqueVehicle: 'El vehículo es una antigüedad.',
    vehicleIsLowered: 'El vehículo se baja',
    forceAllServicesToCashCall: 'Forzar todos los servicios a llamar en efectivo',
    chooseACallBackNumber: 'Elija un número de devolución de llamada',
    addCallbackNumber: 'Añadir número de devolución de llamada',
    fax: 'Fax',
    home: 'Casa',
    mobile: 'Móvil',
    other: 'Otro',
    programTfn: 'Programa TFN',
    work: 'Trabajo',
    benefitLevels: 'Niveles de beneficios',
    policyDetails: 'Detalles de la póliza',
    addresses: 'Direcciones',
    customerNoPolicy: 'No se requiere póliza - Llamada en efectivo',
    customerBenefitLevelEligibilityValid: 'ELEGIBILIDAD DE BENEFICIO DEL CLIENTE: VÁLIDO',
    customerBenefitLevelEligibilityInvalid: 'Policy is expired',
    policyNUmber: 'Número de póliza',
    activeDate: 'Fecha activa',
    expirationDate: 'Fecha de caducidad',
    coverage: 'Cobertura',
    covered: 'Cubierto',
    overMiles: 'Over Miles / Kilometere',
    emailNotVerified: 'CORREO NO VERIFICADO',
    emailVerified: 'CORREO VERIFICADO',
    verify: 'Verificar',
    emailNotFound: 'El correo electrónico no encontrado. Haga clic aquí para actualizar el correo electrónico.',
    updateEmail: 'Actualizar correo electrónico',
    type: 'Escribe',
    phone: 'Teléfono',
    situation: 'Situación',
    reasonForBreakdown: 'Motivo de la avería',
    service: 'Servicio',
    yes: 'Sí',
    no: 'No',
    vehicleAdditionalCostWarning: 'Agregar un vehículo a este plan requerirá un gasto adicional. ¿Está seguro de que le gustaría continuar?',
    callAgentScript: 'Guión de agente de llamada',
    vehicleShiftsOutOfPark: '¿El vehículo sale del estacionamiento?',
    vehicleIsAWD: '¿El vehículo es 4WD (Tracción en las 4 ruedas) o AWD (Todas las ruedas motrices)?',
    vehicleFacingForward: '¿Está el vehículo mirando hacia adelante o retrocediendo en el lugar de estacionamiento?',
    forwardFacing: 'Con Salida Adelante',
    rearFacing: 'Orientado Hacia Atrás',
    currentlyOtherVehiclesParkedAround: '¿Hay otros vehículos estacionados actualmente alrededor de su vehículo?',
    vehicleKeysInPassengerCompartment: '¿Llaves dentro del habitáculo?',
    vehicleKeysInTrunk: '¿Llaves dentro del baúl?',
    inAParkingLot: '¿Está el vehículo en un estacionamiento?',
    vehicleObstructed: '¿Algún otro vehículo que bloquee el acceso a su vehículo para realizar el servicio?',
    parkingLotGarageName: 'Nombre del estacionamiento/garaje',
    nameOfParkingLotGarage: '¿Cuál es el nombre del estacionamiento/garaje?',
    lessThanEightFootClearance: '¿Hay menos de ocho pies de espacio libre en el estacionamiento/garaje?',
    parkedNextToColumn: '¿Estás estacionado al lado de una columna?',
    spaceRowNumber: 'Espacio / Número de fila',
    whatIsSpaceRowNumber: '¿Cuál es el número de espacio/número de fila?',
    lotGarage: 'Piso Lote / Garaje',
    whatFloorIsTheVehicleLocatedOn: '¿En qué piso se encuentra el vehículo?',
    lotGarageFloorDesignation: 'Designación de piso de lote/garaje',
    lotGarageFloorDesignationHelpText: '¿El nivel o piso en el que estacionó tiene un nombre, color o designación específicos?',
    parkingFees: 'Tarifas de estacionamiento',
    parkingFeesHelperText: '¿Cuánto cuestan las tarifas de estacionamiento asociadas con el estacionamiento/garaje?',
    inParkingGarage: '¿Está el vehículo en un aparcamiento?',
    isAccident: '¿Es este servicio consecuencia de un accidente?',
    vehicleFourWheelDrive: '¿El vehículo es 4WD (tracción en las 4 ruedas) o AWD (tracción en todas las ruedas)?',
    vehicleHasMoreThanFourTires: '¿Tiene su vehículo más de 4 neumáticos?',
    vehicleHasRearFlatTire: '¿Tiene su vehículo un neumático trasero pinchado?',
    vehicleHasLivingQuarters: '¿Tiene su vehículo un habitáculo?',
    vehicleHasDuallies: '¿Su vehículo tiene duallies?',
    trailerIsLoaded: '¿Está cargado el remolque?',
    vehicleHeight: '¿Cuál es la altura de su vehículo?',
    vehicleWeight: '¿Cuál es el peso de su vehículo?',
    vehicleLength: '¿Cuál es la longitud de su vehículo?',
    vehicleHitchType: '¿Qué tipo de enganche (bola, ganso, quinta rueda)?',
    towForATrailer: '¿Es un remolque para un remolque (sin motor)?',
    areAnyTiresFlat: '¿Hay algún neumático pinchado?',
    noSpareIsReasonForTow: '¿No tener repuesto es la razón de una grúa?',
    vehicleModifiedLower: '¿Vehículo modificado más bajo hasta el suelo?',
    immediate: 'Inmediato',
    scheduled: 'Programado',
    dateAndTime: 'Fecha y hora',
    unattendedTow: 'Remolque desatendido',
    pleaseReadThisToTheCustomer: 'Por favor lea esto al cliente',
    dial911: 'Si está lesionado y necesita ayuda médica, cuelgue y marque el 911.',
    haveAClaimNumber: '¿Tienes un número de reclamo?',
    havePoliceBeenDispatched: '¿Se ha enviado a la policía?',
    arePoliceOnScene: '¿Está la policía en la escena?',
    claimNumber: 'Numero de reclamo',
    mechanical: 'Mecánico',
    accident: 'Accidente',
    secondary: 'Remolque secundario/decomisado',
    transport: 'Transporte',
    recovery: 'Recuperación',
    rvTechCall: 'Llamada técnica de RV',
    acknowledgeAndAgree: '¿Reconoce y acepta que el vehículo se deja desatendido y renuncia a toda responsabilidad?',
    changeToAttendedTow: 'Change To Attended Tow',
    agree: 'Estar de acuerdo',
    disagree: 'Discrepar',
    whereAreTheKeys: '¿Dónde están las llaves del vehículo?',
    numberOfPeopleWhoNeedARide: '¿Número de personas que necesitan transporte?',
    willTheCallerBeWithTheVehicle: '¿La persona que llama estará con el vehículo?',
    firstName: 'Primer nombre',
    lastName: 'Apellido',
    useCustomerAddress: 'Usar la dirección del cliente',
    pickALocationOnTheMap: 'Elija una ubicación en el mapa o ingrese una nueva ubicación',
    dispatchMap: 'Mapa de despacho',
    provider: 'Proveedor',
    searchingForAvailableProviders: 'Búsqueda de proveedores disponibles'
  }
};
